/*
 * key         The key used to reference this item, and to get the corresponding error message
 * elementId   The element to add the CSS class to (probably an input)
 * type         - string is checked for false and ""
 *              - array is checked for false and length 0
 *              - notZero is parsed to a float and checked for null and !0
 * state       The key(s) of the value we look for in the state
 */

export const getValidators = () => {
  return [
    {
      "key"       : "petName",
      "elementId" : "nppe2-fc-validate-pet-name",
      "type"      : "string",
      "state"     : "petInfoReducer.petName",
    },
    {
      "key"       : "product",
      "elementId" : "nppe2-fc-validate-products",
      "type"      : "array",
      "state"     : "productsReducer.selectedData",
    },
    {
      "key"       : "currentBodyWeight",
      "elementId" : "nppe2-fc-validate-current-body-weight",
      "type"      : "notZero",
      "state"     : "bodyConditionReducer.selectedBodyWeight",
    },
    {
      "key"       : "birthDate",
      "elementId" : "nppe2-fc-validate-birth-date",
      "type"      : "date",
      "state"     : "birthDateReducer.selected",
    },
    {
      "key"       : "criticalCare",
      "elementId" : "nppe2-fc-validate-diagnoses",
      "type"      : "criticalCareNoDiagnoses",
      "state"     : "criticalCareReducer.selected",
    },
  ];
}
